// Copyright (c) Hamilton Manufacturing Corp.
import React, { useContext, useEffect, useState } from 'react';
import Input from '../../_common/form/Input';
import CheckBox from '../../_common/form/CheckBox';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Select from '../../_common/form/Select';
import { Notif } from '../../_pwa/Notification';

const InputUpdater = ({ ...props }) => {
    const {
        state: {
            site_config,
        },
        updateSiteConfig
    } = useGlobalState();

    const { setNotification } = useContext(Notif);

    const [value, setValue] = useState(props.default);

    const updater = props.configUpdater || updateSiteConfig;
    const newConfig = props.initialConfig || site_config;

    useEffect(() => {
        setValue(props.default)
    }, [props.default])

    return props.checkbox ? (
        <CheckBox
            standalone
            readOnly
            label={props.label}
            checked={value}
            onClick={e => {
                setValue(e.target.checked)

                const config = { ...newConfig }
                props.onUpdate(e.target.checked, config);
                updater(config);

                if (props.toast) {
                    setNotification({
                        ...props.toast,
                        config: {
                            position: 'top-right'
                        }
                    })
                }
            }}
        />
    ) : props.select ? (
        <Select
            standalone
            label={props.label}
            value={value}
            onChange={e => {
                setValue(e.target.value)

                const config = { ...newConfig }
                props.onUpdate(e.target.value, config);
                updater(config);

                if (props.toast) {
                    setNotification({
                        ...props.toast,
                        config: {
                            position: 'top-right'
                        }
                    })
                }
            }}
            options={props.options}
        />
    ) : (
        <Input
            standalone
            label={props.label}
            value={value}
            type={props.type}

            onInput={e => {
                let value = e.target.value;
                if (props.type === 'number') {
                    value = parseFloat(value);
                }
                setValue(value)
            }}
            onBlur={() => {
                const config = { ...newConfig }
                props.onUpdate(value, config);
                updater(config);
                if (props.toast) {
                    setNotification({
                        ...props.toast,
                        config: {
                            position: 'top-right'
                        }
                    })
                }
            }}
        />
    );
}

export default InputUpdater;